import React, { useEffect, useState } from 'react'
import { Card, ListGroup } from 'react-bootstrap'
import PropagateLoader from "react-spinners/PropagateLoader"
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { notificationRes, notificationTodo } from '../../LMS_Redux/LMS_Slices/Notification/Notification'
import moment from 'moment'
import NotificationDetails from './NotificationDetails'
import { notificationDetailsRes, notificationDetailsTodo } from '../../LMS_Redux/LMS_Slices/Notification/NotificationDetails'

export default function Notification() {

    const [loading, setLoading] = useState(true)
    const [modalLoading, setModalLoading] = useState(true)
    const [notifyDetails, setNotifyDetails] = useState(false)
    const [bool, setBool] = useState(false)
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const data = useSelector(state => state.notification && state.notification.data && state.notification.data.data)
    // console.log(data)

    const userRole = JSON.parse(localStorage.getItem('user_data'));
    const role = userRole && userRole.vrole_name

    const mergedArray = data && data.Notifications && data.Notifications.map((item) => {
        const user = data && data.UserList && data.UserList.find((obj) => obj.vemp_code === item.fk_user_id);
        return { ...item, user };
    })
    // console.log(mergedArray)

    const notification_details = (id) => {
        setModalLoading(true)
        setNotifyDetails(true)
        dispatch(notificationDetailsTodo(id)).then(() => notification_details_res())
    }

    const notification_details_res = () => {
        if (notificationDetailsRes && notificationDetailsRes.success) {
            setModalLoading(false)
        } else {
            setModalLoading(false)
        }
    }

    const notify_res = () => {
        if (notificationRes && notificationRes.success) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    useEffect(() => {
        setLoading(true)
        dispatch(notificationTodo()).then(() => notify_res())
    }, [bool])

    return (
        <>
            <div className='container-fluid'>
                <div className='scnd-header'>
                    <span className='icon1'>Notification </span>
                </div>


                {loading ?
                    <div className='wrapper-admin'>
                        <div className='text-center mb-3'>
                            <PropagateLoader
                                color="#2262C6"
                                size={20}
                            />
                        </div>
                    </div >
                    :
                    <ListGroup as="ol">
                        {mergedArray && mergedArray.length ?
                            mergedArray && mergedArray.map((val, index) =>
                                role == 'Admin' ?
                                    <ListGroup.Item
                                        as="li"
                                        className="d-flex justify-content-between align-items-center"
                                        key={index}
                                    >
                                        <div className="me-auto">
                                            {role == 'Admin' ?
                                                <div className="fw-bold" style={{ color: 'rgba(34, 98, 198, 0.6)' }}>{`${val?.user?.vemp_fname} - (${val?.user?.vemp_company_code})`}</div>
                                                : ''
                                            }
                                            <div className="fw-bold">{val && val.notification_title}</div>
                                            {val && val.notification_message}
                                        </div>
                                        <div className="fw-bold" style={{ fontSize: '20px', color: '#2262C6' }}>{val && moment(val.createdAt).format('DD/MM/YYYY')}</div>
                                    </ListGroup.Item>
                                    :
                                    <Card className='mb-2' key={index} style={val?.seen_status ? { cursor: 'pointer' } : { backgroundColor: 'rgba(255, 242, 204, 0.6)', cursor: 'pointer' }} onClick={() => notification_details(val?.id)}>
                                        <Card.Body className='d-flex justify-content-between align-items-center' style={{ padding: '0.5rem' }} >
                                            <div className="me-auto">
                                                {role == 'Instructor' ?
                                                    <div className="fw-bold" style={{ color: 'rgba(34, 98, 198, 0.6)' }}>{`${val?.user?.vemp_fname} - (${val?.user?.vemp_company_code})`}</div>
                                                    : ''
                                                }
                                                <div className="fw-bold">{val && val.notification_title}</div>
                                            </div>
                                            <div className="fw-bold" style={{ fontSize: '20px', color: '#2262C6' }}>{val && moment(val.createdAt).format('DD/MM/YYYY')}</div>
                                        </Card.Body>
                                    </Card>
                            )
                            :
                            <div className='wrapper-admin'>
                                <div className='text-center'>
                                    No notifications found
                                </div>
                            </div>
                        }
                    </ListGroup>
                }
            </div >

            <NotificationDetails
                modalLoading={modalLoading}
                notifyDetails={notifyDetails}
                setNotifyDetails={setNotifyDetails}
                bool={bool}
                setBool={setBool}
            />
        </>
    )
}
